import { Controller } from "stimulus"
import axios from "axios";

export default class extends Controller {
  update() {
    const stationId = this.element.dataset.stationId
    const url = `/api/v1/stations/${stationId}/update_package_type`
    axios.patch(url, { station: { package_type_id: this.element.value } })
  }
}